import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-flex tw-justify-center tw-items-center tw-p-2 recetas" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-bg-gray-50 tw-rounded tw-shadow tw-py-4 tw-px-8 tw-text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Ordenes")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "tw-flex",
  style: {"max-height":"calc(100vh - 28vh)"}
}
const _hoisted_4 = {
  ref: "contenedorResultados",
  class: "tw-w-full tw-overflow-auto tw-flex-1 tw-grid xl:tw-grid-cols-2 tw-gap-2 tw-bg-gray-100 tw-p-2 tw-rounded"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-w-full tw-bg-gray-50 tw-rounded tw-shadow tw-py-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "No se encontraron datos.", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_recetas_card = _resolveComponent("recetas-card")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toast, { position: "bottom-right" }),
    _createVNode(_component_Card, {
      style: {"background":"none","box-shadow":"none"},
      class: "animate tw-m-auto tw-w-full"
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (_ctx.ordenesList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordenesList, (item) => {
                  return (_openBlock(), _createBlock(_component_recetas_card, {
                    key: item,
                    dato: item,
                    onDescargar: ($event: any) => (_ctx.descargarRecetas(item, $event)),
                    isLoading: item.isLoading,
                    showEstado: true
                  }, null, 8, ["dato", "onDescargar", "isLoading"]))
                }), 128))
              ], 512)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      ]),
      _: 1
    })
  ]))
}